/**
 * Film action types for Redux store
 */

export const FETCH_FILMS_REQUEST = "FETCH_FILMS_REQUEST";
export const FETCH_FILMS_SUCCESS = "FETCH_FILMS_SUCCESS";
export const FETCH_FILMS_FAILURE = "FETCH_FILMS_FAILURE";
export const CLEAR_FILMS_CACHE = "CLEAR_FILMS_CACHE";
export const INVALIDATE_FILMS_TAG = "INVALIDATE_FILMS_TAG";

export type FilmActionTypes =
    | typeof FETCH_FILMS_REQUEST
    | typeof FETCH_FILMS_SUCCESS
    | typeof FETCH_FILMS_FAILURE
    | typeof CLEAR_FILMS_CACHE
    | typeof INVALIDATE_FILMS_TAG;
